let captchaLoaded = false
let createCaptchaToken
let createCaptchaTokenWrapper
let pendingCaptchaInit = true
let captchaInitResolver
let captchaInitPromise = new Promise(resolver => {
  captchaInitResolver = resolver
})

const setupCaptcha = (captchaType, captchaId, turnStileSiteKey, captchaVisibility) => {
  if (createCaptchaTokenWrapper) return createCaptchaTokenWrapper
  if (captchaType === 'google' && !captchaId) return console.warn('Google CaptchaID is missing')
  if (captchaType === 'turnstile' && !turnStileSiteKey)
    return console.warn('TurnStile site key is missing')

  // add dynamic script tag
  let script = document.createElement('script')
  document.getElementsByTagName('head')[0].appendChild(script)

  switch (captchaType) {
    case 'turnstile':
      script.setAttribute('src', `https://challenges.cloudflare.com/turnstile/v0/api.js`)
      script.onload = () => {
        createCaptchaToken = async action => {
          return new Promise((resolve, reject) => {
            const turnstileContainer = document.createElement('div')
            turnstileContainer.id = 'turnstile-container'
            document.body.appendChild(turnstileContainer)

            const widget = turnstile.render(document.body, {
              sitekey: turnStileSiteKey, // Replace with your actual site key
              theme: 'light', // Optional: "light" or "dark"
              callback: token => {
                console.log('token', token)
                resolve(token)
                turnstile.remove(widget)
              },
              errorCallback: () => {
                reject('Error getting captcha token')
                turnstile.remove(widget)
              },
              action: action, // Optional: Define a custom action
              //              appearance: 'execute',
            })
            turnstile.execute(widget)
          })
        }

        pendingCaptchaInit = false
        captchaInitResolver()
      }
      break
    default:
      script.setAttribute('src', `https://www.google.com/recaptcha/api.js?render=${captchaId}`)

      script.onload = () => {
        window.grecaptcha.ready(async () => {
          hideCaptchaBadge(captchaVisibility)
          createCaptchaToken = async action => window.grecaptcha.execute(captchaId, { action })
          pendingCaptchaInit = false
          captchaInitResolver()
        })
      }
  }

  if (!createCaptchaTokenWrapper) {
    createCaptchaTokenWrapper = async action => {
      if (pendingCaptchaInit) await captchaInitPromise
      return createCaptchaToken(action)
    }
  }

  return createCaptchaTokenWrapper
}

const hideCaptchaBadge = visibility => {
  if (visibility) {
    const badge$ = document.querySelector('.grecaptcha-badge')
    if (badge$) badge$.style.visibility = 'hidden'
  }
}

export default setupCaptcha
